import { GoatAwkward, useIntl } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';
import styled from 'styled-components';

export type NotEnoughFanTokensDrawerProps = {
	closeModal: () => void;
	minAmount?: string;
	testID: string;
};

export const NotEnoughFanTokensDrawer = ({ closeModal, minAmount, testID }: NotEnoughFanTokensDrawerProps) => {
	const { $t } = useIntl();

	const description = (
		<S.DescriptionWrapper>
			<span>{$t('wallet.withdraw.notEnoughFanTokensDrawer.descriptionPart1', { minAmount })}</span>
			<span>{$t('wallet.withdraw.notEnoughFanTokensDrawer.descriptionPart2')}</span>
			<S.DescriptionList>
				<li>{$t('wallet.withdraw.notEnoughFanTokensDrawer.descriptionPart3')}</li>
				<li>{$t('wallet.withdraw.notEnoughFanTokensDrawer.descriptionPart4')}</li>
			</S.DescriptionList>
		</S.DescriptionWrapper>
	);

	const notEnoughFanTokensDrawerData = {
		buttonText: $t('wallet.withdraw.notEnoughFanTokensDrawer.buttonText'),
		description: description,
		image: GoatAwkward,
		testID: testID,
		title: $t('wallet.withdraw.notEnoughFanTokensDrawer.title')
	};

	return <GenericDrawer {...notEnoughFanTokensDrawerData} onButtonPress={closeModal}></GenericDrawer>;
};

namespace S {
	export const DescriptionWrapper = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxxsmall};
		align-items: center;
	`;
	export const DescriptionList = styled.ul`
		margin-right: ${({ theme }) => theme.spacings.xsmall};
		text-align: center;
		list-style-position: inside;
	`;
}
